import { render, staticRenderFns } from "./Relation.vue?vue&type=template&id=109f73f0&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"
import style0 from "./Relation.vue?vue&type=style&index=0&id=109f73f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109f73f0",
  null
  
)

export default component.exports